import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }


export const getMissionAction = createAsyncThunk(
    'get-mission',
    async (data = null, { rejectWithValue }) => {
        try {
            const res = await axios.get(`/admins/api/get-mission?is_deleted=${data?.is_deleted}&sub_cat_id=${data?.sub_cat_id}&s_date=${data?.s_date}&e_date=${data?.e_date}`)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const getMissionSlice = createSlice({
    name: 'get-mission',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(getMissionAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(getMissionAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(getMissionAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const getMissionReducer = getMissionSlice.reducer    